<template>
  <div class="material-details" :data-product-id="product.id">
    <div
      class="material-container"
      v-if="product && product.materials && product.materials.length > 0"
      :class="{covered: !!currentMaterial}"
    >
      <div
        v-for="material in product.materials"
        :key="material.number"
        class="material"
        @click="onMaterialSelected(material)"
      >
        <div class="icon"></div>
        <div class="material-name">{{material.name}}</div>
        <div class="more">{{labels.more}}</div>
      </div>
    </div>
    <div
      class="no-files"
      v-if="doublechecked && (!product.materials || product.materials.length === 0)"
      v-html="labels.noSDSFiles"
    ></div>
    <SDSDownloads
      :material="currentMaterial"
      v-if="currentMaterial"
      @close="onCloseDownloads"
      @loaded="onFilesLoaded"
    ></SDSDownloads>
  </div>
</template>

<script>
import Labels from "../services/labels.js";
import Utils from "../services/utils.js";
import DataLayer from "../services/datalayer.js";
import SDSDownloads from "./SDSDownloads.vue";

export default {
  name: "MaterialDetails",
  components: {
    SDSDownloads
  },
  props: ["product"],
  data() {
    return {
      labels: Labels,
      currentMaterial: null,
      numFiles: 0,
      hasBestFile: false,
      doublechecked:
        this.$props.product.materials &&
        this.$props.product.materials.length > 0
    };
  },
  mounted() {
    if (
      this.$props.product &&
      (!this.$props.product.materials ||
        this.$props.product.materials.length === 0)
    ) {
      //we check again for materials, using the bulk number of the product
      //use case: user searches for oil. Solr returns Antifrogen SOL, EHS returns nothing (it does not hold product descriptions)
      //as a result, no packaging options are available initially
      //in such cases, when the user wants to see such a product, we perform an material search using the product bulk number
      let self = this;
      let loader = Utils.showLoader(
        `.material-details[data-product-id="${self.$props.product.id}"]`
      );
      DataLayer.getMaterials(this.$props.product.bulkNumber, this.$props.product.title)
        .then(res => {
          Utils.removeLoader(loader);
          self.$props.product.materials = res.data;
          self.doublechecked = true;
        })
        .catch(err => {
          Utils.removeLoader(loader);
          Utils.showStatusMessage(
            `Error loading product packaging options: ${err}`,
            "red"
          );
        });
    }
  },
  methods: {
    onMaterialSelected(material) {
      if (!material) return;
      this.currentMaterial = material;
      Utils.reportToAnalytics("DocFinder SDS Material Selected", material.name);
      let el = document.querySelector(
        `div.material-details[data-product-id='${this.$props.product.id}']`
      );
      if (el) {
        if (!el.style.minHeight || el.style.minHeight == "0px") el.style.minHeight = `140px`;
      }
    },
    onCloseDownloads() {
      this.currentMaterial = null;
      this.numFiles = 0;
      this.hasBestFile = false;
      let el = document.querySelector(
        `div.material-details[data-product-id='${this.$props.product.id}']`
      );
      if (el) {
        el.style.minHeight = `0px`;
      }
    },
    onFilesLoaded(numFiles, hasBestFile) {
      this.numFiles = numFiles;
      this.hasBestFile = hasBestFile;
      //we need to do it this way due to a conflict with one of the clariant scripts
      //it prevents the setting dynamically the minHeight style.
      let panelHeight = this.getPanelHeight();
      let el = document.querySelector(
        `div.material-details[data-product-id='${this.$props.product.id}']`
      );
      if (el) {
        el.style.minHeight = `${panelHeight}px`;
      }
    },
    getPanelHeight() {
      if (!this.currentMaterial || this.numFiles === 0) return 200;
      let height = this.numFiles * 45 + (this.hasBestFile ? 45 : 0);
      height += 24; //title
      height += 166; //disclaimer on top of additional files, country dropdown plus margin
      if (this.hasBestFile) {
        height += 44; //best file disclaimer plus margins
      }
      height += 10; //paddings
      return height;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.material-details {
  width: 100%;
  position: relative;
  display: flex;
}

.material-container {
  padding: 10px;
}

.material-container.covered {
  /*background-color: rgba(88,88,88,0.2);*/
}

.material {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}

.material .icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 302.36 302.36'%3E%3Cdefs%3E%3CclipPath id='a' clipPathUnits='userSpaceOnUse'%3E%3Cpath d='M0 2267.7V0h2267.7v2267.7z'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg fill='%23231f20' clip-path='url(%23a)' transform='matrix(.13333 0 0 -.13333 0 302.36)'%3E%3Cpath d='M883.102 1052.85c-7.809 7.81-20.469 7.81-28.282 0l-67.05-67.049c-7.813-7.813-7.813-20.473 0-28.281 7.812-7.809 20.468-7.809 28.281 0l32.91 32.91V841.621c0-11.051 8.957-20 20-20 11.047 0 20 8.949 20 20V990.43l32.914-32.91a19.9 19.9 0 0114.137-5.86 19.908 19.908 0 0114.14 5.86c7.813 7.808 7.813 20.468 0 28.281l-67.05 67.049M1000.35 957.52c7.81-7.809 20.47-7.809 28.28 0l32.91 32.91V841.621c0-11.051 8.96-20 20-20 11.05 0 20 8.949 20 20V990.43l32.91-32.91a19.916 19.916 0 0114.14-5.86c5.12 0 10.24 1.949 14.14 5.86 7.81 7.808 7.81 20.468 0 28.281l-67.05 67.049c-7.81 7.81-20.47 7.81-28.28 0l-67.05-67.049c-7.815-7.813-7.815-20.473 0-28.281'/%3E%3Cpath d='M1530.92 787.82l-296.67 508.4 58.41 34.09 296.66-508.412zm-275.35-3.359H671.023v324.329h584.547zM916.012 1354.09l-23.965-27.27-23.953 27.27v133.14h47.918zm717.938-529.309l-316.81 542.959a20.08 20.08 0 01-12.19 9.27c-5.17 1.36-10.6.61-15.17-2.07l-92.97-54.25a20 20 0 01-9.26-12.19 19.955 19.955 0 012.07-15.16l84.35-144.55h-224.5v358.44c0 11.05-8.95 20-20 20H651.023c-11.046 0-20-8.95-20-20v-58.57c0-11.04 8.954-20 20-20 11.043 0 20 8.96 20 20v38.57h157.071v-140.68c0-4.86 1.765-9.55 4.969-13.2l43.957-50.03a20.015 20.015 0 0115.027-6.8 19.98 19.98 0 0115.019 6.8l43.965 50.03a19.96 19.96 0 014.981 13.2v140.68h53.458v-338.44H671.023v175.46c0 11.04-8.957 20-20 20-11.046 0-20-8.96-20-20V764.461c0-11.039 8.954-20 20-20h624.547c11.05 0 20 8.961 20 20v347.299l210.87-361.369c3.72-6.379 10.41-9.922 17.3-9.922 3.42 0 6.89.883 10.06 2.722l92.96 54.239a20.02 20.02 0 019.26 12.191 19.958 19.958 0 01-2.07 15.16'/%3E%3C/g%3E%3C/svg%3E");
  width: 32px;
  min-width: 32px;
  height: 32px;
  background-size: 70px;
  background-position: 50%;
  margin-right: 20px;
}

.material-container.covered .icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 302.36 302.36'%3E%3Cdefs%3E%3CclipPath id='a' clipPathUnits='userSpaceOnUse'%3E%3Cpath fill='%23888888' d='M0 2267.7V0h2267.7v2267.7z'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg fill='%23888888' clip-path='url(%23a)' transform='matrix(.13333 0 0 -.13333 0 302.36)'%3E%3Cpath d='M883.102 1052.85c-7.809 7.81-20.469 7.81-28.282 0l-67.05-67.049c-7.813-7.813-7.813-20.473 0-28.281 7.812-7.809 20.468-7.809 28.281 0l32.91 32.91V841.621c0-11.051 8.957-20 20-20 11.047 0 20 8.949 20 20V990.43l32.914-32.91a19.9 19.9 0 0114.137-5.86 19.908 19.908 0 0114.14 5.86c7.813 7.808 7.813 20.468 0 28.281l-67.05 67.049M1000.35 957.52c7.81-7.809 20.47-7.809 28.28 0l32.91 32.91V841.621c0-11.051 8.96-20 20-20 11.05 0 20 8.949 20 20V990.43l32.91-32.91a19.916 19.916 0 0114.14-5.86c5.12 0 10.24 1.949 14.14 5.86 7.81 7.808 7.81 20.468 0 28.281l-67.05 67.049c-7.81 7.81-20.47 7.81-28.28 0l-67.05-67.049c-7.815-7.813-7.815-20.473 0-28.281'/%3E%3Cpath d='M1530.92 787.82l-296.67 508.4 58.41 34.09 296.66-508.412zm-275.35-3.359H671.023v324.329h584.547zM916.012 1354.09l-23.965-27.27-23.953 27.27v133.14h47.918zm717.938-529.309l-316.81 542.959a20.08 20.08 0 01-12.19 9.27c-5.17 1.36-10.6.61-15.17-2.07l-92.97-54.25a20 20 0 01-9.26-12.19 19.955 19.955 0 012.07-15.16l84.35-144.55h-224.5v358.44c0 11.05-8.95 20-20 20H651.023c-11.046 0-20-8.95-20-20v-58.57c0-11.04 8.954-20 20-20 11.043 0 20 8.96 20 20v38.57h157.071v-140.68c0-4.86 1.765-9.55 4.969-13.2l43.957-50.03a20.015 20.015 0 0115.027-6.8 19.98 19.98 0 0115.019 6.8l43.965 50.03a19.96 19.96 0 014.981 13.2v140.68h53.458v-338.44H671.023v175.46c0 11.04-8.957 20-20 20-11.046 0-20-8.96-20-20V764.461c0-11.039 8.954-20 20-20h624.547c11.05 0 20 8.961 20 20v347.299l210.87-361.369c3.72-6.379 10.41-9.922 17.3-9.922 3.42 0 6.89.883 10.06 2.722l92.96 54.239a20.02 20.02 0 019.26 12.191 19.958 19.958 0 01-2.07 15.16'/%3E%3C/g%3E%3C/svg%3E");
}

.material-container.covered .material-name {
  color: #888888;
}
</style>